import clsx from "clsx";
import type { FunctionComponent } from "react";

type Props = {
	bold?: boolean;
	className?: string;
};

const DetailsListDivider: FunctionComponent<Props> = ({bold=false}) => {
	return <div className={clsx("col-span-2 h-px", bold ? "bg-gray-200" : "bg-gray-100")}/>;
};

export default DetailsListDivider;